import FileInput from './components/FileInput';

export default FileInput;



// WEBPACK FOOTER //
// ./src/index.js